import React from "react";
import {
  BotRegular,
  BranchRegular,
  BriefcaseRegular,
  ClipboardTaskListLtrRegular,
  FolderRegular,
  GavelRegular,
  HistoryRegular,
  HomeRegular,
  ServerRegular,
} from "@fluentui/react-icons";

type NavIconProps = { className?: string };

const BLADE_ICON_MAP: Record<string, React.ComponentType<NavIconProps>> = {
  overview: HomeRegular,
  work: FolderRegular,
  agents: BotRegular,
  decisions: GavelRegular,
  review: ClipboardTaskListLtrRegular,
  instances: ServerRegular,
  system_actions: HistoryRegular,
  git_checkouts: BranchRegular,
  jobs: BriefcaseRegular,
};

export function BladeNavIcon({
  bladeId,
  className,
}: {
  bladeId: string;
  className?: string;
}) {
  const Icon = BLADE_ICON_MAP[bladeId] ?? FolderRegular;
  return <Icon className={className} />;
}

/** Blade ids the rail must not show as standalone nav entries. */
export const HIDDEN_NAV_BLADE_IDS = new Set(["knowledge"]);

/** Knowledge base sits directly after Overview in the sidebar. */
export function orderedNavBlades<T extends { id: string }>(blades: T[]): T[] {
  const filtered = blades.filter((blade) => !HIDDEN_NAV_BLADE_IDS.has(blade.id));
  const overview = filtered.find((blade) => blade.id === "overview");
  const work = filtered.find((blade) => blade.id === "work");
  const rest = filtered.filter(
    (blade) => blade.id !== "overview" && blade.id !== "work",
  );
  const ordered: T[] = [];
  if (overview) {
    ordered.push(overview);
  }
  if (work) {
    ordered.push(work);
  }
  ordered.push(...rest);
  return ordered;
}

export function knowledgeBaseLabel(bladeId: string, serverLabel: string): string {
  return bladeId === "work" ? "Knowledge base" : serverLabel;
}
